// extracted by mini-css-extract-plugin
export default {"button":"Button_button__v04EB","buttonLink":"Button_buttonLink__gT2AU"};